// extracted by mini-css-extract-plugin
export default {"cooperationDescribe":"Cooperation_cooperationDescribe__6-bUm"};